import type * as React from 'react';
import { Text, Box, Strong, Hidden } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { IJobApplicationStore } from '../../../../stores/JobApplicationStore';
import translations from '../.vocab';
import { useTranslations } from '@vocab/react';

interface Props {
  jobApplicationStore: IJobApplicationStore;
}

const SearchResultSummaryBase: React.FC<Props> = ({ jobApplicationStore }) => {
  const { t } = useTranslations(translations);
  const {
    currentPreFilterTotalOfJobApplications,
    currentTotalOfJobApplications,
    hasSearchText,
    lastResultSearchText,
    isLoaded,
    filtersStore,
  } = jobApplicationStore;

  if (!isLoaded) {
    return null;
  }

  if (!hasSearchText && !filtersStore.hasSelectedFilter) {
    return (
      <Hidden above="mobile">
        <Box paddingY="xxsmall" />
      </Hidden>
    );
  }

  const getResultMessage = () => {
    if (hasSearchText) {
      return t('labelCount for lastResultSearchText', {
        labelCount: currentTotalOfJobApplications,
        lastResultSearchText,
      });
    } else if (filtersStore.hasSelectedFilter) {
      return (
        <>
          {t(
            'currentTotalOfJobApplications out of currentPreFilterTotalOfJobApplications application/s match your filters',
            {
              currentTotalOfJobApplications,
              currentPreFilterTotalOfJobApplications,
              Strong: (children) => (
                <Strong key="total-number-of-apps">{children}</Strong>
              ),
            },
          )}
        </>
      );
    }
  };

  const resultMessage = getResultMessage();
  return (
    <Box padding={['medium', 'none']}>
      <Text>{resultMessage}</Text>
    </Box>
  );
};

export const SearchResultSummary = observer(SearchResultSummaryBase);
